import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {
  Button,
  Tip,
} from 'modules/theme';
export class InfoDetail extends Component {
  render() {
    const { message } = this.props;
    return (
      <Tip text={message} key={parseInt(Math.random()*1000)}>
        <Button
          btnStyle="link"
          style={{ "verticalAlign": 'middle',"padding": "0px 10px","fontSize": "17px"}}
          icon={'info-circle'}
        ></Button>
      </Tip>
    )
  }
}
InfoDetail.contextTypes = {
  __: PropTypes.func
};

export default InfoDetail;



// WEBPACK FOOTER //
// ./src/modules/common/components/InfoDetail.js